/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'
import { getBearerToken } from '@modules/auth/auth'
import withRouter from '@modules/routing/withRouter'

import { redirectAfterLogin, fetchAuthMethods } from '@/actions/auth'
import { getAuthMethods } from '@/reducers/authMethods'
import { fetchAuthMethodsRequest } from '@/reducers/asyncRequests/registry'

import { isFeatureActivated } from '../../../../selectors'

import LoginIndex from './LoginIndex'

import type { ConsumerProps, DispatchProps, StateProps } from './types'
import type { ReduxState } from '@/types/redux'

const mapStateToProps = (
  state: ReduxState,
  { router: { location } }: ConsumerProps,
): StateProps => {
  const { hash } = location
  const basicAuthProxyPassEnabled = isFeatureActivated(state, Feature.basicAuthProxyPass)
  const newBearerToken = basicAuthProxyPassEnabled ? getBearerToken(hash) : null

  return {
    authMethods: getAuthMethods(state),
    fetchAuthMethodsRequest: fetchAuthMethodsRequest(state),
    newBearerToken,
  }
}

const mapDispatchToProps: DispatchProps = {
  redirectAfterLogin,
  fetchAuthMethods,
}

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(LoginIndex),
)
